// Коэффициент инфляции
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { backUrl } from "../../config";

const redPath = "kiApi"; // change
const tagApi = "ki"; // change

export const kiApi = createApi({ // change
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getKi: build.query({
      // change
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createKi: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}`,
        method: "POST",
        body: {
          data: {
            ...newData,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateKi: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {useGetKiQuery, useCreateKiMutation, useUpdateKiMutation} = kiApi; // change
